module.exports = __webpack_public_path__ + "static/media/diary_btn_try.f081d17e.png";